import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import { Box, Typography, Dialog, DialogTitle, DialogContent, IconButton, Table, TableBody, TableCell, TableRow, AppBar, Toolbar, TableHead, TableFooter, TablePagination  } from '@mui/material';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import { Close, CloudDownloadRounded } from '@mui/icons-material';
import Currency from '../../common/Currency';
import Pagination from '../../../container/MUI/Pagination';
import StackedStats from '../../Stats/StackedStats';
import SpendingDetails from '../../Spendings/SpendingDetails';
import Schedule from '../../EmployeeView/TimeSheet/Schedule';
import ScheduleAdmin from '../Timesheet/ScheduleAdmin';
import { extension } from 'mime-types';
import TitleWithEndAction from '../../common/TitleWithEndAction';
import IncomesList from '../Incomes/IncomesList';

const STATUS = {
    "WAITING_VALIDATION": "En Attente de Validation",
    "VALIDATE": "Validé",
    "REFUSED": "Refusé"
}

class ProjectSingle extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        spendings: [],
        total: 0,
    }
    componentDidMount = async () => {
        this.filterSpendings()
        this.filterSteps()
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    displayLabels = (labels) => {
        const { LABELS } = this.props;
        return labels.split(', ').map(label => LABELS && LABELS[label] && LABELS[label].label_name)
    }

    filterSpendings = () => {
        const { SPENDINGS, project } = this.props;
        let filteredList = !isEmpty(SPENDINGS) ? 
        Object.values(SPENDINGS).filter(
            item => {
                let projects = item.spending_project.split(", ")
                return projects.includes(project.project_id)
            }
        ) : 
        []
        
        console.log('====================================');
        console.log({filteredList});
        console.log('====================================');
        let total = 0
        filteredList.forEach(item => total += item.spending_amount)
        // filteredList.forEach(item => total += item.spending_amountTTC)
        this.setState({
            spendings: filteredList,
            total
        })
    }

    filterSteps = () => {
        const { STEPS, project } = this.props;
        let filteredList = !isEmpty(STEPS) ? 
        Object.values(STEPS).filter(item => item.project_id === project.project_id) : []
        
        console.log('====================================');
        console.log({filteredList});
        console.log('====================================');
        let totalSteps = 0
        filteredList.forEach(item => totalSteps += item.project_step_amount)
        this.setState({
            steps: filteredList,
            totalSteps
        })
    }
    displaySpendings = () => {
        const { rowsPerPage, page, spendings } = this.state;
        const { CATEGORIES, SUPPLIERS, LABELS } = this.props;
        
        return spendings.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( item => {
            let category = CATEGORIES.CHILD[item.spending_category]
            // let user = isEmpty(USERS) ? {} : USERS[item.spending_user]
            let labels = LABELS && item.spending_labels && this.displayLabels(item.spending_labels)
            // let projects = PROJECTS && item.spending_project && this.displayProjects(item.spending_project)
            let supplier = isEmpty(SUPPLIERS) ? {} : SUPPLIERS[item.spending_supplier]

            return (
                <TableRow 
                    hover
                    key={item.spending_id}
                    onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                >
                    <TableCell >
                        {new Date(item.spending_date).toLocaleDateString('fr-FR')}
                    </TableCell>
                    <TableCell >{category && category.category_name}</TableCell>                     
                    <TableCell >{item.spending_desc}</TableCell>   
                    <TableCell >{supplier && supplier.supplier_name}</TableCell>   
                    {/* <TableCell >{projects && projects.join(", ")}</TableCell>    */}
                    <TableCell >{labels && labels.join(", ")}</TableCell>   
                    <TableCell ><Currency value={item.spending_amount} /></TableCell>                     
                    {/* <TableCell ><Currency value={item.spending_amountTTC} /></TableCell>                      */}
                    <TableCell >
                        {!item.spending_fully_paid &&
                            <Currency value={item.spending_rest_to_pay} />
                        }
                    </TableCell>                     
                    
                </TableRow>
            )
        })
    }
    displaySteps = () => {
        const { rowsPerPage, page, steps } = this.state;
        // const { CATEGORIES, SUPPLIERS, LABELS } = this.props;
        
        return steps.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( item => (
                <TableRow 
                    hover
                    key={item.project_step_id}
                    // onClick={() => this.setState({openDetails: true, selectedSpending: item }) }
                >
                    <TableCell >
                        {new Date(item.project_step_date).toLocaleDateString('fr-FR')}
                    </TableCell>
                    <TableCell >{item.project_step_ref}</TableCell>   
                    <TableCell >{item.project_step_name}</TableCell>   
                    <TableCell >{item.project_step_desc}</TableCell>   
                    <TableCell ><Currency value={item.project_step_amount} /></TableCell>                     
                    <TableCell>
                        {!isEmpty(item.project_step_files) &&
                            <a href={`/photos/single/${item.project_step_files[0].filename}`} 
                                download={`project_${this.props.project.project_name}_${item.project_step_name}.${ extension(item.salary_files[0].filetype) || "pdf"}`}
                            >
                                <IconButton >
                                    <CloudDownloadRounded />
                                </IconButton>      
                            </a>
                        }
                    </TableCell>                     
                    
                </TableRow>
        ))
    }
    render() {
        const { project, CATEGORIES, SUPPLIERS, PAYMENTS, BANKS, PROJECTS, LABELS } = this.props;
        const { spendings, steps, rowsPerPage, page, total, selectedSpending, openDetails} = this.state;
        return (
            <Dialog
                // disableBackdropClick
                open={true}
                // onClose={this.props.handleClose}
                onClose={(_, reason) => {reason !== "backdropClick" && this.props.handleClose()} }
                aria-labelledby="form-dialog-title"
                maxWidth="lg"
                fullScreen
                scroll="paper"
            >
                {openDetails && selectedSpending && 
                    <SpendingDetails 
                        supplier={SUPPLIERS && SUPPLIERS[selectedSpending.spending_supplier]} 
                        LABELS={LABELS}
                        PROJECTS={PROJECTS}
                        BANKS={BANKS}
                        PAYMENTS={PAYMENTS}
                        category={CATEGORIES.CHILD && CATEGORIES.CHILD[selectedSpending.spending_category]} 
                        spending={selectedSpending} 
                        view="ADMIN"
                        handleClose={()=> this.setState({openDetails: false, selectedSpending: {}})}
                        fetchSpendingPayments={this.props.fetchSpendingPayments}
                    />
                }
                <AppBar style={{position: 'relative'}} color="secondary">
                    <Toolbar>
                        <IconButton color="inherit" onClick={this.props.handleClose} aria-label="Close">
                            <Close />
                        </IconButton>
                        <Typography variant="h6" color="inherit">
                        {project.project_name}
                        </Typography>
                    </Toolbar>
                </AppBar>
                <DialogContent>
                    <Box>
                        <SwipeableTabs
                            labels={["Statistiques", "Etapes", "Dépenses", "Planning", "Recettes"]}
                        >
                            <Box p={3}>
                                Total: <Currency value={total} />
                                <StackedStats 
                                    CATEGORIES={this.props.CATEGORIES.CHILD}
                                    SPENDINGS={this.state.spendings}
                                />
                            </Box>
                            <Box p={3}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Date</TableCell>
                                            <TableCell>Ref</TableCell>
                                            <TableCell>Nom</TableCell>
                                            <TableCell>Description</TableCell>
                                            <TableCell>Montant</TableCell>
                                            <TableCell>Documents</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!isEmpty(steps) && this.displaySteps()}
                                    </TableBody>
                                    {size(steps) > 10 &&
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[10, 30]}
                                                    labelRowsPerPage="Lignes par Page"
                                                    colSpan={7}
                                                    count={size(steps)}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        native: true,
                                                    }}
                                                    onPageChange={this.handleChangePage}
                                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                                    ActionsComponent={Pagination}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    }
                                </Table>
                            </Box>
                            <Box p={3}>
                                <TitleWithEndAction
                                    title= " "
                                    action={() => this.props.openFormCustom(this.props.project.project_id)}
                                />
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Créé le</TableCell>
                                            <TableCell>Catégorie</TableCell>
                                            <TableCell>Description</TableCell>
                                            <TableCell>Fournisseur</TableCell>
                                            <TableCell>Labels</TableCell>
                                            <TableCell>Montant HT</TableCell>
                                            <TableCell>Reste à Payer</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {!isEmpty(spendings) && !isEmpty(CATEGORIES.CHILD) && this.displaySpendings()}
                                    </TableBody>
                                    {size(spendings) > 10 &&
                                        <TableFooter>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[10, 30]}
                                                    labelRowsPerPage="Lignes par Page"
                                                    colSpan={7}
                                                    count={size(spendings)}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    SelectProps={{
                                                        native: true,
                                                    }}
                                                    onPageChange={this.handleChangePage}
                                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                                    ActionsComponent={Pagination}
                                                />
                                            </TableRow>
                                        </TableFooter>
                                    }
                                </Table>
                            </Box>
                            <Box p={3}>
                                <ScheduleAdmin
                                    {...this.props}
                                    projectID={project.project_id}
                             
                                    // view="admin"
                                />
                            </Box>
                            <Box p={3}>
                            <IncomesList                
                                    {...this.props}
                                    projectID={project.project_id}
                                    listOnly={true}
                                    />
                            </Box>
                        </SwipeableTabs>
                    </Box>
                </DialogContent>
            </Dialog>
        );
    }
}

export default ProjectSingle;